import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../shared/shared.module';
import { ChangePasswordComponent } from './change-password/change-password';
import { GameSalesReportComponent } from './game-sales-report/game-sales-report';
import { RetailPayComponent } from './retail-pay/retail-pay';
import { RetailRemitanceComponent } from './retail-remitance/retail-remitance';
import { Angular4PaystackModule } from 'angular4-paystack';
import { RetailCancelComponent } from './retail-cancel/retail-cancel';
import { RetailBalanceReportComponent } from './retail-balance-report/retail-balance-report';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxPaginationModule } from 'ngx-pagination';
@NgModule({  
  declarations: [
    ChangePasswordComponent,
    GameSalesReportComponent,
    RetailPayComponent,
    RetailRemitanceComponent,
    RetailCancelComponent,
    RetailBalanceReportComponent
  ],
  imports: [
    Angular4PaystackModule,
    CommonModule,
    FormsModule,
    MyDatePickerModule,
    NgxPaginationModule,  
    IonicPageModule.forChild(RetailersModule),
  ],
  exports:[
    ChangePasswordComponent,
    GameSalesReportComponent,
    RetailPayComponent,
    RetailRemitanceComponent,
    RetailCancelComponent,
    RetailBalanceReportComponent




    // RetailGameSaleReportComponent,
    // RetailReportComponent,
    // RetailCancelComponent,
    // RetailPayComponent,
    // RetailRemitComponent
  ]
})
export class RetailersModule { }



// WEBPACK FOOTER //
// ./src/app/retailer/retails.module.ts